import React from 'react';
import {Route} from 'react-router-dom';
import {connect} from 'react-redux';

let mapStateToProps = ({authEndpoint}) => {
    return {
      userRoles: authEndpoint.roles,
    };
  };

class RoleRoute extends React.Component {
  
  render() {
    let hasAccess = this.props.roles.reduce((valid, roleName) => {
      return valid || !!this.props.userRoles.find(r=>r.RoleName === roleName);
    }, false);
    let {component: Component, userRoles, roles, ...rest} = this.props;
    return (
      <Route
        {...rest}
        render={(props) => hasAccess
          ? <Component {...props} />
          : <span>Not Found</span>}
      />
    );
  }
}

class RoleContentComponent extends React.Component {
  
  render() {
    let hasAccess = this.props.roles.reduce((valid, roleName) => {
      return valid || !!this.props.userRoles.find(r=>r.RoleName === roleName);
    }, false);
    return (
        hasAccess ? <div>{this.props.children}</div> : null
    );
  }
}

export let RoleContent = connect(mapStateToProps)(RoleContentComponent);
export default connect(mapStateToProps)(RoleRoute);



// WEBPACK FOOTER //
// ./src/components/RoleRoute.js